import { Box, Typography } from '@mui/material'

import GridItem from '@ecm/ui/element/GridItem'
import MainContainer from '@ecm/ui/element/MainContainer'

const benefits = [
  {
    description: (
      <>
        Choose a real street address or PO box from one of our <b>80+ U.S. addresses.</b>
      </>
    ),
    heading: 'Prestigious address',
    icon: 'location-pin',
  },
  {
    description: <>We digitize your postal mail so you can read or download it from anywhere.</>,
    heading: 'Mail digitization',
    icon: 'scan',
  },
  {
    description: (
      <>
        Your postal mail is digitized into fully searchable, <b>high-resolution PDFs.</b>
      </>
    ),
    heading: 'Full-text search',
    icon: 'document',
  },
  {
    description: (
      <>
        Integrate with cloud and accounting software providers like
        <b> Dropbox, Google Drive, Box, and Bill.com.</b>
      </>
    ),
    heading: 'Software integrations',
    icon: 'integrations',
  },
  {
    description: (
      <>Use our mobile app or web browser to access your postal mail from your phone or tablet.</>
    ),
    heading: 'Fully mobile',
    icon: 'action',
  },
  {
    description: (
      <>
        Your data is protected with <b>256-bit encryption</b>, and stored in our secure facilities.
      </>
    ),
    heading: 'World-class security',
    icon: 'secure-delivery',
  },
]

const Benefits = () => (
  <MainContainer sx={{ py: '6em' }}>
    <Typography variant="h3" component="h2">
      Postal mail as convenient as email
    </Typography>
    <Box
      pt={{ md: '4em', xs: '2em' }}
      display="grid"
      gridTemplateColumns={{ md: '1fr 1fr 1fr', sm: '1fr 1fr', xs: '1fr' }}
      gap="3em"
    >
      {benefits.map(({ description, ...otherProps }) => (
        <GridItem key={otherProps.heading} {...otherProps} alignCenter>
          {description}
        </GridItem>
      ))}
    </Box>
  </MainContainer>
)
export default Benefits
